const TrackingKey = {

        START_CHAT_SUCCESS: "start_chat_success",
        START_CHAT_FAIL:"start_chat_fail",
        LOGIN_SUCCESS:"login_success",
        LOGIN_FAIL:"login_fail",
        FAQ_QUERY:"faq_query",
        SCENARIO_QUERY:"scenario_query",
        FEEDBACK_SKIPPED:"feedback_skipped",
        CLOSE_CHAT_YES:"close_chat_yes",
        CLOSE_CHAT_NO:"close_chat_no",
        SSO_PROFILE_SINGLE:'sso_profile_single',
        SSO_PROFILE_MULTIPLE:'sso_profile_multiple',
        SSO_PROFILE_NO_ACCOUNT:'sso_profile_no_account',
        INTENT_READING_SUCCESS:"intent_reading_success",
        INTENT_READING_FAIL:"intent_reading_fail",
        ERROR_FRONTEND:"error_frontend",
        ERROR_BACKEND:"error_backend",
        IDLE_CHAT:"idle_chat",
        RETRY_OPTION:"retry_option",
        FEEDBACK_HAPPY:"feedback_happy",
        FEEDBACK_SAD:"feedback_sad",
        IMPROVE_FEEDBACK:"improve_feedback",
        IMPROVE_FEEDBACK_SKIPPED:"improve_feedback_skipped",
        GRID_CLICKS:'grid_clicks',
        LINK_CLICKS:'link_clicks',
        SWITCH_CLICK_PRE_TO_POST:'switch_click_pre_to_post',
        SWITCH_CLICK_POST_TO_PRE:'switch_click_post_to_pre'


}

export default TrackingKey


// WEBPACK FOOTER //
// ./src/enums/trackingKey.js